import { MediaAsset } from "pages/media/types";
import { useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import AssetLibraryDetail from "./AssetLibraryDetail";
import { useOrganization } from "hooks/useOrganization";
import { AssetType, useMediaAssets } from "./useMediaAssets";

export const useSortedAssets = (
  assets: MediaAsset[] | Partial<MediaAsset>[]
) => {
  const images = useMemo(
    () =>
      assets?.filter(
        (asset) =>
          asset.category === "AssetImage" ||
          (asset.category === "FromStockContent" &&
            asset.asset_type === "Picture")
      ),
    [assets]
  );
  const music = useMemo(
    () => assets?.filter((asset) => asset.category === "Music"),
    [assets]
  );
  const fonts = useMemo(
    () => assets?.filter((asset) => asset.category === "Font"),
    [assets]
  );

  const videos = useMemo(
    () =>
      assets?.filter(
        (asset) =>
          asset.category === "Video" ||
          (asset.category === "FromStockContent" &&
            asset.asset_type === "Video")
      ),
    [assets]
  );
  return { images, music, fonts, videos, assets };
};

export const AssetLibraryEdit = ({ isEdit }: { isEdit?: boolean }) => {
  const { organization } = useOrganization({});
  const params = useParams();
  const [activeTab, setActiveTab] = useState<AssetType>("images");
  const organizationId = organization?.id;
  const currentAssetLibraryId = params.id;

  const { assets, updateAllAssets, deleteAsset, hasMore, fetchNextPage } =
    useMediaAssets(currentAssetLibraryId, organizationId);

  return (
    <AssetLibraryDetail
      isEdit={isEdit}
      assets={assets}
      id={currentAssetLibraryId}
      organizationId={organizationId}
      isModal={false}
      onUploadComplete={updateAllAssets}
      onDeleteComplete={deleteAsset}
      hasMore={hasMore}
      setActiveTab={setActiveTab}
      activeTab={activeTab}
      fetchNextPage={() => {
        void fetchNextPage();
      }}
    />
  );
};
